var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.8 21 3 19.2l7.2-7.2L3 4.8 4.8 3l7.2 7.2L19.2 3 21 4.8 13.8 12l7.2 7.2-1.8 1.8-7.2-7.2L4.8 21Z"
})));
export default SvgClose;